var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.33337,
    y: 3.33325,
    width: 53.3333,
    height: 53.3333,
    rx: 26.6667,
    fill: "#FEF0C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.33337,
    y: 3.33325,
    width: 53.3333,
    height: 53.3333,
    rx: 26.6667,
    stroke: "#FFFAEB",
    strokeWidth: 6.66667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 25.5555V29.9999M29.9999 34.4444H30.011M28.0999 19.8444L18.6888 35.5555C18.4948 35.8915 18.3921 36.2725 18.391 36.6605C18.3899 37.0485 18.4904 37.4301 18.6826 37.7672C18.8747 38.1043 19.1518 38.3852 19.4862 38.582C19.8207 38.7788 20.2008 38.8846 20.5888 38.8888H39.411C39.799 38.8846 40.1791 38.7788 40.5136 38.582C40.848 38.3852 41.1251 38.1043 41.3172 37.7672C41.5094 37.4301 41.6099 37.0485 41.6088 36.6605C41.6077 36.2725 41.505 35.8915 41.311 35.5555L31.8999 19.8444C31.7018 19.5178 31.4229 19.2478 31.0901 19.0605C30.7573 18.8731 30.3818 18.7747 29.9999 18.7747C29.618 18.7747 29.2425 18.8731 28.9097 19.0605C28.5769 19.2478 28.298 19.5178 28.0999 19.8444Z",
    stroke: "#DC6803",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarning);
export default __webpack_public_path__ + "static/media/red_warning.ebe132a27d9be64fd6323a13ce8b6114.svg";
export { ForwardRef as ReactComponent };